import { settleApiCall } from './settleApiCall';
import type { PanoramaErrorMonitor } from '@wix/panorama-client/dist/types/panorama-error-monitor';
import type { ErrorMonitorUserData } from '@wix/panorama-client/dist/types/types';
import type { BaseOperationDurationParams } from 'root/services/biReporterService';
import { withBIDuration } from 'root/utils/withBIDuration';

export type ReportError =
  | ((error: Error | string) => string | undefined)
  | ((ex: Error | ErrorEvent | string) => void);

export const getMonitoredApiCall = async <T, R extends BaseOperationDurationParams>({
  callback,
  name,
  operationDurationBIEvent,
  operationDurationParams,
  fedops,
  errorMonitor,
  reportError,
  excludeErrors,
  onError,
}: {
  callback: () => Promise<T>;
  name?: string;
  operationDurationBIEvent?: (params: R) => void;
  operationDurationParams?: R;
  fedops?: { start?: Function; end?: Function };
  errorMonitor?: PanoramaErrorMonitor<ErrorMonitorUserData>;
  reportError?: ReportError;
  excludeErrors?: string[];
  onError?: (error: Error) => void;
}) => {
  return new Promise<{ data?: T; error?: Error }>(async (resolve, reject) => {
    fedops?.start?.();
    errorMonitor?.addBreadcrumb({
      category: 'api',
      message: fedops?.start?.name ?? '',
    });
    const { data, error } = await settleApiCall<T>(() =>
      withBIDuration<T, R>({
        callback,
        monitorBiEvent: operationDurationBIEvent!,
        params: operationDurationParams,
        name,
        isAPI: true,
      })
    );
    if (error) {
      if (!excludeErrors?.some((e) => error.message.indexOf(e) > -1)) {
        errorMonitor ? errorMonitor?.reportError(error) : reportError && reportError(error);
      } else {
        fedops?.end?.();
      }
      onError?.(error);
    } else {
      fedops?.end?.();
    }

    resolve({ data, error });
  });
};
